import { useState, useEffect, useContext } from 'react'

// Internal context
import { ModalContext } from '../../context/ModalContext'
import { AppContext } from '../../context/AppContext'
import { UserContext } from '../../context/UserContext'

// Utils
import { readCookie } from '../../utils/store/cookies'

const legacyModalDateStorageKey = 'legacyModalDateStorageV3'

const AppController = () => {
  // Contexts
  const modalContext = useContext(ModalContext)
  const appContext = useContext(AppContext)
  const userContext = useContext(UserContext)

  // States
  const [appLegacyState, setAppLegacyState] = useState(false)

  useEffect(() => {
    // if (userContext.loadedSession || userContext.loggedIn || userContext?.userSession?.code !== 401) return false
    setAppLegacyState(true)
  }, [userContext])

  useEffect(() => {
    getAppLegacyEvents()
  }, [appLegacyState])

  const getAppLegacyEvents = () => {
    const event = checkForAppLegacyEvent()
    const modalPropsObj = getModalPropsObject(event)
    const storageCheck = sessionStorage.getItem(legacyModalDateStorageKey)
    if (modalPropsObj) {
      if (!storageCheck || storageCheck !== event) {
        modalContext.openModal(modalPropsObj)
        sessionStorage.setItem(legacyModalDateStorageKey, event)
      }
    }
  }

  const shouldShowModalUpdateIos = () => {
    const check = appContext?.isNativeApp && appContext?.isLegacyiOSApp
    return check
  }

  const shouldShowModalUpdateAndroid = () => {
    const check = appContext?.isNativeApp && appContext?.isLegacyAndroidApp
    return check
  }

  const shouldShowModalMaintenance = () => {
    let bypass = false
    const check = process.env.NEXT_PUBLIC_MAINTENANCE_MODE && process.env.NEXT_PUBLIC_MAINTENANCE_MODE !== 'false'
    if (check) {
      bypass = readCookie('bypassmaintenance') || false
    }

    return check && !bypass
  }

  const checkForAppLegacyEvent = () => {
    let event = false
    if (shouldShowModalUpdateIos()) event = 'updateios'
    if (shouldShowModalUpdateAndroid()) event = 'updateandroid'
    if (shouldShowModalMaintenance()) event = 'maintenance'

    return event
  }

  const getModalPropsObject = (event) => {
    switch (event) {
      case 'updateios':
        return { type: 'api', route: 'get/user/updateios', modifier: 'Modal--onboarding', mandatory: true }
      case 'updateandroid':
        return { type: 'api', route: 'get/user/updateandroid', modifier: 'Modal--onboarding', mandatory: true }
      case 'maintenance':
        return { type: 'api', route: 'get/user/maintenance', modifier: 'Modal--onboarding', mandatory: true }
      default:
        return false
    }
  }

  // pure functional component
  return <></>
}

export default AppController
